import Home from '@/pages/Home';

function load (component) {
    // route level code-splitting
    // this generates a separate chunk for route
    // which is lazy-loaded when the route is visited.
    return () => import(`@/pages/${component}.vue`);
}

const routes = [
    {path: "/", name: "home", component: Home, meta: { layout: "basic", noauth: true }},
    {path: "/about", name: "about", component: load("About"), meta: { layout: "basic", noauth: true }},
    {path: "/activities", name: "activities", component: load("Activities"), meta: { layout: "basic", noauth: true }},
    {path: "/raport", name: "raport", component: load("Raport"), meta: { layout: "basic"}},
    {path: "/cctv", name: "cctv", component: load("Cctv"), meta: { layout: "basic"}},
    {path: "/wahana", name: "wahana", component: load("Wahana"), meta: { layout: "basic", noauth: true}},
    {path: "/ticketing", name: "ticketing", component: load("Ticketing"), meta: { layout: "basic", noauth: true }},
    {path: "/ticketing_group", name: "ticketing_group", component: load("TicketingGroup"), meta: { layout: "basic" }},
    {path: "/daftar_reguler", name: "daftar_reguler", component: load("DaftarReguler"), meta: { layout: "basic" }},
    {path: "/daftar_paket", name: "daftar_paket", component: load("DaftarPaket"), meta: { layout: "basic" }},
    {path: "/riwayat_pemesanan", name: "riwayat_pemesanan", component: load("RiwayatPemesanan"), meta: { layout: "basic" }},
    {path: "/login", name: "login", component: load("auth/login"), meta: { layout: "basic-login", noauth: true }},
    {path: "/register", name: "register", component: load("auth/register"), meta: { layout: "basic-login", noauth: true }},
    {path: "/lupa_password", name: "lupa_password", component: load("auth/password/email"), meta: { layout: "basic-login", noauth: true }},
    {path: "/reset_password/:id", name: "reset_password", component: load("auth/password/reset"), meta: { layout: "basic-login", noauth: true }},
    {path: "/dashboard", name: "dashboard", component: load("Dashboard")},
    { path: "*", component: load("errors/404") }
];

export default routes;